<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="4">
                    <ValidationProvider name="evaluation_exam_definition_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('evaluation_type')">
                            <evaluation-exam-definition-selectbox v-model="formData.evaluation_exam_definition_id"
                                                                  @program-code-changed="selectedProgramCode = $event"
                                                                  :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="graduate_application_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('student')">
                            <graduate-application-selectbox v-model="formData.graduate_application_id" :program_code="selectedProgramCode" :validateError="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="score" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('score')">
                            <b-form-input v-model="formData.score" :validate-error="errors[0]"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="createForm" :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import GraduateApplicationSelectbox from "@/components/interactive-fields/GraduateApplicationSelectbox.vue";
import EvaluationExamDefinitionSelectbox from "@/components/interactive-fields/EvaluationExamDefinitionSelectbox.vue";

// Services
import GraduateApplicationEvaluationExamsService from "@/services/GraduateApplicationEvaluationExamsService";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"

export default {
    components: {
        GraduateApplicationSelectbox,
        EvaluationExamDefinitionSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            formData: {
                graduate_application_id: null,
                evaluation_exam_definition_id: null,
                score: null,
            },
            selectedProgramCode: null,
            formLoading: false,
        }
    },
    methods: {
        async createForm() {
            if(this.checkPermission('graduateapplicationquota_store')){
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid) {
                    this.formLoading = true;
                    GraduateApplicationEvaluationExamsService.store(this.formData)
                        .then(response => {
                            this.$toast.success(this.$t(response.data.message));
                            this.$emit('createFormSuccess', true);
                        })
                        .catch(e => {
                            this.showErrors(e, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false
                        })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>
